import React from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as EyeIco} from "../../../../../images/icons/eye.svg";
import {DateHelper} from "../../../../services/Common/Date/DateHelper";
import {ConfigApi, OrderType} from "../../../../services/Api/types";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";

interface Props {
    locale?: string;
    onClick: () => void;
    category: any;
    orderType: OrderType;
    menus: any[];
    items: any[];
    availabilities: any[];
    config: ConfigApi | undefined;
    pickupDate: string | undefined;
}

const MenuCategoryAvailabilityInfo = ({
                                          locale,
                                          onClick,
                                          category,
                                          orderType,
                                          menus,
                                          items,
                                          availabilities,
                                          config,
                                          pickupDate
                                      }: Props) => {
    const {t} = useTranslation();
    const infos = CategoryHelper.getAvailabilityInfo(category, menus, items, availabilities, config, orderType, pickupDate, t, locale);

    const drawInfo = (info: { text: string; typesText?: string; dateText?: string; isNowAvailable?: boolean; }) => {
        let restOfText = "";
        const typesText = info.typesText ? `${info.typesText} ${info.isNowAvailable ? '' : '-'}` : "";

        restOfText += typesText;

        if (info.dateText) {
            restOfText += ` ${info.isNowAvailable ? '' : info.dateText}`;
        }

        return (
            <>
                <span>
                    {info.text}
                </span>
                <span>{restOfText}</span>
            </>
        )
    }

    return (
        <div
            className="menu-category-availability-info d-flex flex-column align-items-center justify-content-center fw-normal"
            onClick={onClick}>
            {
                infos.filter((_, index) => index < 2).map((info, index) => (
                    <div className="d-flex flex-column text-center text-warning"
                         key={`${JSON.stringify(info)}-${index}`}>
                        {drawInfo(info)}
                    </div>
                ))
            }
            {infos.length > 2 && (
                <div className="d-flex flex-column text-center text-warning">
                    ...
                </div>
            )}
            <EyeIco className="mt-1"/>
        </div>
    )
}

export default MenuCategoryAvailabilityInfo;